<template>
  <footer class="footer">
    <div class="footer__inner">
      <p class="footer__text">18+ &copy; T2 Россия, {{ year }}</p>
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear();
</script>

<style lang="scss" scoped>
.footer {
  background: var(--colorBlack);
  // В макете на мобильном текст стоит на y=16, а высота подвала — 60px.
  padding: 16px 12px 32px;

  @include md {
    // В макете текст стоит на x=64 при 1440 (y=32, высота 12 → 76).
    padding: 32px 64px;
  }
}

.footer__inner {
  width: 100%;
  max-width: var(--widthContainer);
  margin: 0 auto;
}

.footer__text {
  font-size: 10px;
  line-height: 12px;
  color: #6b717f;
}
</style>
